module.exports = __webpack_public_path__ + "img/icon (24).0bbb802d.png";